export default function List(theme: any) {
  return {
    MuiListItem: {
      variants: [
        {
          props: { variant: "outlined" },
          style: {},
        },
      ],
      styleOverrides: {
        root: {
          color: "#D6D6D6",
          position: "relative",
          "&.active": {
            color: theme.palette.grey[0],
          },
          "&::before": {
            content: '""',
            position: "absolute",
            border: "1px solid transparent",
            left: 0,
            top: "50%",
            transform: "translate(0, -50%)",
            transition: "all .3s ease-in-out",
            height: 0,
          },
          "&.active::before": {
            border: `1px solid ${theme.palette.grey[0]}`,
            backgroundColor: theme.palette.grey[0],
            borderRadius: "8px",
            height: "64px",
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "32px",
        },
      },
    },
  };
}
